import { observable } from "mobx";
import noop from "lodash/noop";

class ModalModel {
    @observable isOpen = false;
    @observable title = "";

    constructor(modalKey, modalTitle = "", modalWillClose = noop) {
        this.modalKey = modalKey;
        this.title = modalTitle;
        this.modalWillClose = modalWillClose;
    }

    open() {
        this.isOpen = true;
    }

    close(dispatcher) {
        this.modalWillClose();
        this.isOpen = false;
        if (dispatcher) {
            dispatcher.emit("HIDE_MODAL", {
                modalKey: this.modalKey
            });
        }
    }
}

export default ModalModel;
